"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEntryPointURL = void 0;
const _1 = require(".");
const environment_types_1 = require("../types/environment.types");
/**
 * Constructs the URL for the entry point of the application
 *
 * @param host - the host url based on the environment
 * @param entryPoint - the entry point of the application
 * @param appName - the name of the application that the AdSDK is trying to load
 * @param environment - the environment name in which the AdSDK is running
 * @returns the entry point URL
 */
const getEntryPointURL = (params) => {
    const { host, entryPoint, appName, environment } = params;
    if (environment === environment_types_1.EnvironmentName.Local) {
        return `${(0, _1.getLocalHostBasedOnApplication)(appName)}/${entryPoint}`;
    }
    return `${host}/${_1.APPS_DIRECTORY}/${appName}/${entryPoint}`;
};
exports.getEntryPointURL = getEntryPointURL;
//# sourceMappingURL=get-entrypoint-url.js.map